import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  HIDE_MESSAGE,
  SHOW_MESSAGE,
  TOGGLE_APP_DRAWER,
  UPDATING_CONTENT,
  SHOW_BACK_DROP,
  HIDE_BACK_DROP,
  MESSAGE_BACK_DROP,
  SET_SELECTED_YEAR,
} from 'shared/constants/ActionTypes';

const INIT_STATE = {
  error: '',
  loading: false,
  isAppDrawerOpen: false,
  updatingContent: false,
  message: '',
  backDropLoading: false,
  backDropMessage: '',
  selectedYear: '2024',
};

const commonReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_START: {
      return {...state, error: '', message: '', loading: true};
    }
    case UPDATING_CONTENT: {
      return {...state, error: '', message: '', updatingContent: true};
    }
    case FETCH_SUCCESS: {
      return {
        ...state,
        error: '',
        message: '',
        loading: false,
        updatingContent: false,
      };
    }
    case SHOW_MESSAGE: {
      return {
        ...state,
        error: '',
        message: action.payload,
        loading: false,
        updatingContent: false,
      };
    }
    case FETCH_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: '',
        updatingContent: false,
      };
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        loading: false,
        error: '',
        message: '',
        updatingContent: false,
      };
    }
    case TOGGLE_APP_DRAWER: {
      return {
        ...state,
        isAppDrawerOpen: !state.isAppDrawerOpen,
      };
    }
    case SHOW_BACK_DROP: {
      return {
        ...state,
        backDropLoading: true,
      };
    }
    case HIDE_BACK_DROP: {
      return {
        ...state,
        backDropLoading: false,
        backDropMessage: '',
      };
    }
    case MESSAGE_BACK_DROP: {
      return {
        ...state,
        backDropMessage: action.payload,
      };
    }
    case SET_SELECTED_YEAR:
      return {
        ...state,
        selectedYear: action.payload,
      };
    default:
      return state;
  }
};
export default commonReducer;
